import React from 'react';

import CountUp from 'react-countup';

import { type BaseCurrencyType } from '@pkg/types';

import { DiffValue } from './DiffValue';

import { DiffWrapper, Label, SubLabel, Value, ValueWrapper, Wrapper } from './styles';

interface Props {
    label: string;
    value: number;
    currency?: BaseCurrencyType;
    subLabel?: string;
    diffPercent?: number;
    diffNumber?: number;
    diffDirection?: 'up' | 'down';
}

export const StatsItem = ({ label, value, subLabel, currency, diffPercent, diffNumber, diffDirection }: Props) => {
    const decimals = !currency ? 0 : 4;

    return (
        <Wrapper>
            <Label>{label}</Label>
            <ValueWrapper>
                <Value>
                    <CountUp
                        end={value}
                        decimal="."
                        prefix={currency === 'usd' ? '$' : ''}
                        decimals={currency === 'usd' ? 2 : decimals}
                        preserveValue
                    />
                </Value>
                <DiffWrapper>
                    <DiffValue percent={diffPercent} number={diffNumber} direction={diffDirection} />
                    {subLabel && <SubLabel>{subLabel}</SubLabel>}
                </DiffWrapper>
            </ValueWrapper>
        </Wrapper>
    );
};
